const apiUrl = process.env.NEXT_PUBLIC_API_URL;

export async function postData(endpoint: string, data: any) {
    try {
        const response = await fetch(
            `${apiUrl ?? 'https://image-nations-api.fly.dev'}${endpoint}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || 'An error occurred');
        }

        return result;
    } catch (error) {
        console.error('Error in postData:', error);
        throw error;
    }
}
